import React from 'react';
import { useField } from 'formik';
import { TextField } from '@mui/material';

const MyTextArea = ({ label, disabled = false, autoComplete = 'off', rows = 4, ...props }) => {

    const [field, meta] = useField(props);

    return (

        <TextField
            sx={{ width: '100%' }}
            variant='outlined'
            autoComplete={autoComplete}
            label={label}
            multiline // 👈 esto le dice que sea textarea
            rows={rows} // 👈 puedes controlar cuántas filas quieres
            disabled={disabled}
            {...field}
            {...props}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
        />

    )

}

export default MyTextArea